export default {
  "bank.ux.revokePayeeWarning": "Atsaukt saņēmēja apstiprinājumu",
  "bank.ux.warningAccepted": "OWNER Finance pieņēma brīdinājumu; banka nav apstiprinājusi saņēmēju.",
  "bank.ux.acceptPayeeWarning": "Saprotu, ka banka nav apstiprinājusi saņēmēju, un atļauju izveidot melnrakstu ar šiem rekvizītiem.",
  "bank.ux.checkNotPossible": "Banka nevarēja pārbaudīt saņēmēju.",
  "bank.ux.checkPending": "Banka laikus nav atgriezusi rezultātu. Tas nenozīmē, ka IBAN ir nepareizs.",
  "bank.ux.creatingDrafts": "Veidojam bankas melnrakstus…",
  "bank.ux.checkInvalidIban": "IBAN nav norādīts vai tas nav derīgs. Ievadiet pareizo saņēmēja IBAN.",
  "bank.ux.checkPermission": "Jūsu lomai vai bankas pilnvarojumam trūkst tiesību. Lūdziet organizācijas administratoram pārbaudīt piekļuvi.",

  "bank.ux.checkIssues": "Jāpieņem lēmums par saņēmēju pārbaudēm",
  "bank.ux.checkIssuesHelp": "Bankas melnraksti vēl nav izveidoti. Pārskatiet brīdinājumus. OWNER Finance var pieņemt nesekmīgas pārbaudes rezultātu un turpināt.",
  "bank.ux.checkMismatch": "Banka neapstiprināja konta atbilstību saņēmējam. Pārbaudiet IBAN.",
  "bank.ux.checkName": "Apstipriniet bankas ieteikto saņēmēja nosaukumu.",
  "bank.ux.checkUnavailable": "Saņēmēju neizdevās pārbaudīt. Mēģiniet vēlreiz vai pārbaudiet rekvizītus.",
  "bank.ux.acceptBankName": "Apstiprināt bankas norādīto saņēmēja nosaukumu: {name}",
  "bank.ux.correctRecipientIban": "Labotais saņēmēja IBAN (tukšs — saglabāt esošo)",
  "bank.ux.checkingRecipients": "Pārbaudām saņēmējus…",
  "bank.ux.recheckAndContinue": "Pārbaudīt vēlreiz un turpināt",
  "bank.ux.checkAndContinue": "Pārbaudīt saņēmējus un turpināt",

  "payables.dueBefore": "Apmaksāt līdz",
  "payables.currency": "Valūta",
  "payables.allCurrencies": "Visas valūtas",
  "payables.selectFiltered": "Atlasīt pēc filtra",
  "payables.clearSelection": "Notīrīt atlasi",
  "payables.selectSupplier": "Atlasīt piegādātāju",
  "payables.selectionLimit": "Atlasiet līdz 100 rēķiniem. Sašauriniet filtru.",
  "payables.chooseCurrency": "Izvēlieties vienu valūtu.",

  "bank.ux.timeBudgetPaused": 'Izveidoti {created} melnraksti; vēl nav izveidoti {remaining}. Izveide apturēta savlaicīgi bankas atbilžu saņemšanai. Gatavie melnraksti ir saglabāti.',
  "bank.ux.timeBudgetNotCreated": 'Šis melnraksts bankā vēl nav izveidots.',
  "bank.ux.continueRemaining": 'Turpināt atlikušos',
  "bank.ux.enableDescription": "Pievienojiet BluOr, lai sagatavotu maksājumu melnrakstus piegādātājiem. Maksājumi tiek apstiprināti bankā.",
  "bank.ux.bankSandbox": "Šis savienojums izmantos BluOr bankas testa vidi.",
  "bank.ux.enableBank": "Iestatīt BluOr",
  "bank.ux.platformSetupRequired": "Platformas administratoram vispirms jāiespējo bankas integrācija.",
  'bank.ux.setupUnavailable': 'Šai organizācijai bankas savienojumi vēl nav iespējoti. Administratoram jāiespējo bankas iestatīšana.',
  "bank.ux.ownerOrganization": "Īpašnieka organizācija",
  "bank.ux.ownerMissing": "Organizācija nav piesaistīta",
  "bank.ux.savedRefreshError": "Izmaiņas ir saglabātas, bet kontu sarakstu neizdevās atjaunināt. Pārlādējiet lapu, lai redzētu pašreizējo statusu.",
  "bank.ux.title": "Maksājumi piegādātājiem",
  "bank.ux.subtitle": "Sagatavojiet maksājumu sarakstus un pārvaldiet bankas. Maksājumus paraksta bankā.",
  "bank.ux.business": "Uzņēmums",
  "bank.ux.organization": "Maksātāja organizācija",
  "bank.ux.selectedOrganization": "Izvēlētā organizācija",
  "bank.ux.banks": "Manas bankas",
  "bank.ux.prepare": "Sagatavot maksājumu sarakstu",
  "bank.ux.saved": "Saglabātie saraksti",
  "bank.ux.more": "Citas darbības",
  "bank.ux.settings": "Bankas iestatījumi",
  "bank.ux.accounts": "Organizācijas konti",
  "bank.ux.supplierAccounts": "Apstiprināt piegādātāju kontus",
  "bank.ux.access": "Kas var sagatavot maksājumus",
  "bank.ux.history": "Darbību vēsture",
  "bank.ux.support": "Informācija atbalstam",
  "bank.ux.connect": "Pievienot banku",
  "bank.ux.empty": "Pievienojiet banku, lai pārbaudītu piekļuvi organizācijas kontiem.",
  "bank.ux.reading": "Piekļuve kontiem apstiprināta",
  "bank.ux.readOnly": "Piekļuve kontiem ir pārbaudīta. Maksājumu melnrakstu izveide šajā bankā vēl nav pieejama.",
  "bank.ux.draftSupport": "Savienojums atbalsta bankas maksājumu melnrakstus. Pieejamās darbības ir atkarīgas arī no jūsu tiesībām.",
  "bank.ux.test": "Testa savienojums",
  "bank.ux.pending": "Turpināt iestatīšanu",
  "bank.ux.state.DRAFT": "Iestatīšana nav pabeigta",
  "bank.ux.state.VALIDATING": "Pārbauda piekļuvi",
  "bank.ux.state.ACTIVE": "Piekļuve pārbaudīta",
  "bank.ux.state.SUSPENDED": "Apturēts",
  "bank.ux.state.ERROR": "Nepieciešama darbība",
  "bank.ux.state.DRAINING": "Slēdz pēc pašreizējām darbībām",
  "bank.ux.state.RETIRED": "Atvienots",
  "bank.ux.checked": "Pēdējā pārbaude: {date}",
  "bank.ux.notChecked": "Piekļuve vēl nav pārbaudīta",
  "bank.ux.setupTitle": "Bankas pievienošana",
  "bank.ux.step": "{current}. solis no {total}",
  "bank.ux.credentialsHelp": "Ievadiet bankas izsniegtos piekļuves datus. Tie tiek nosūtīti droši un pēc saglabāšanas notīrīti.",
  "bank.ux.where": "Kur atrast šos datus?",
  "bank.ux.whereHint": "Izmantojiet BluOr piekļuves datus pēc publiskās atslēgas reģistrācijas. Ja nav Client ID vai Client Secret, pieprasiet tos bankā.",
  "bank.ux.registration": "BluOr internetbankā atveriet Settings → Key Management → Add Files. Augšupielādējiet publisko atslēgu, atlasiet to un nospiediet Send. Tad atgriezieties šeit.",
  "bank.ux.computer": "Varat turpināt datorā: piesakieties tai pašai organizācijai un atveriet Manas bankas. Progress tiek saglabāts, paroles netiek pārsūtītas.",
  "bank.ux.rotate": "Atjaunināt piekļuves datus",
  "bank.ux.disconnect": "Atvienot banku",
  "bank.ux.accountHelp": "Ja konts nav atrasts, pievienojiet vai aktivizējiet organizācijas IBAN sadaļā Bankas iestatījumi → Organizācijas konti un atkārtojiet pārbaudi.",
  "bank.ux.self": "Es",
  "bank.ux.advanced": "Citi piekļuves saņēmēji",
  "bank.ux.authorityHint": "Piekļuves piešķiršana ir atsevišķa darbība. Bankas pievienošana nepiešķir tiesības sagatavot maksājumus.",
  "merchant.ap.debtorAccountIdentifier": "Organizācijas IBAN",
  "merchant.ap.subjectType": "Piešķirt piekļuvi",
  "merchant.ap.createAuthority": "Atļaut sagatavot maksājumus",
  "merchant.ap.connectionScope": "Banka šai piekļuvei",
  "merchant.ap.anyConnection": "Visi pieejamie savienojumi",
  "bank.wizard.payer": "Maksātāja organizācija",
  "bank.wizard.generateKey": "Izveidot savienojuma atslēgu",
  "bank.wizard.keyHint": "Izveidojiet savienojuma atslēgu. Bankai tiek nodota tikai publiskā daļa.",
  "bank.wizard.brokerUnavailable": "Savienojuma iestatīšana īslaicīgi nav pieejama. Progress ir saglabāts; sazinieties ar platformas administratoru.",
  "bank.wizard.step.COMPLETE": "Apstipriniet savienojumu",
  "bank.wizard.step.PUBLIC_KEY": "Lejupielādējiet atslēgu bankai",
  "bank.wizard.step.KEY": "Izveidojiet savienojuma atslēgu",
  "bank.wizard.step.REGISTRATION": "Reģistrējiet atslēgu bankā",
  "bank.ux.account.SUPERSEDED": "Aizstāts ar jaunāku konta versiju",
  "bank.ux.account.CANDIDATE": "Gaida aktivizēšanu",
  "bank.ux.account.ACTIVE": "Konts pieejams",
  "bank.ux.account.ARCHIVED": "Arhivēts",
  "bank.ux.account.REJECTED": "Nepieciešams labojums",
  "bank.ux.searchRecipient": "Meklēt pēc vārda",
  "bank.ux.user": "Darbiniekam",
  "bank.ux.party": "Organizācijai",
  "bank.ux.businessScope": "Piekļuves uzņēmumi: {count}",
  "bank.ux.accessActive": "Piekļuve piešķirta",
  "bank.ux.accessEnded": "Piekļuve beigusies",
  "merchant.ap.payment.title": "Sagatavot maksājumu sarakstu",
  "merchant.ap.payment.hint": "Izvēlieties piegādātāju rēķinus, pārbaudiet un saglabājiet sarakstu. Melnrakstu izveide bankā ir atsevišķs solis.",
  "merchant.ap.loading": "Ielāde…",
  "bank.ux.expires": "Saraksts derīgs līdz {date}",
  "bank.ux.activity": "Bankas iestatījumu izmaiņas",
  "bank.ux.activityAccess": "Maksājumu sagatavošanas piekļuves izmaiņas",
  "bank.ux.activityKey": "Savienojuma atslēgas lejupielāde",
  "bank.ux.employee": "Darbinieks",
  "bank.ux.system": "Sistēma",
  "bank.ux.prepareShort": "Jauns saraksts",
  "merchant.ap.payment.review": "Pārbaudīt sarakstu",
  "merchant.ap.verifiedCapabilities": "Bankas iespējas",
  "bank.ux.unavailable": "Bankas savienojumam vai kontam nepieciešama uzmanība. Pārbaudiet bankas iestatījumus.",
  "payments.workspace.title": "Piegādātāju maksājumi",
  "payments.workspace.recipient": "Saņēmējs",
  "payments.workspace.status": "Maksājuma statuss",
  "payments.workspace.group": "Grupēt pēc saņēmēja",
  "payments.workspace.bankDraftHint": "Nosūtīts bankai nozīmē, ka melnraksts ir pieejams parakstīšanai. Apmaksa ir pabeigta tikai pēc apstiprinājuma.",
  "payments.workspace.invoices": "Rēķini",
  "payments.workspace.details": "Rēķini un maksājuma mērķis",
  "payments.workspace.review": "Atvērt rēķina pārbaudi",
  "payments.workspace.open": "Atvērt maksājumu",
  "payments.workspace.closePreparation": "Aizvērt sagatavošanu",
  "payments.workspace.prepare": "Sagatavot maksājumus",
  "payments.workspace.incoming": "Ienākošie rēķini Goods sadaļā",
  "payments.workspace.sourceHint": "Maksājumi tiek veidoti no pārbaudītiem un uzskaitītiem rēķiniem Goods sadaļā. Pirms bankas melnraksta sagatavošanas pārbaudiet summu un saņēmēju.",
  "payments.state.REVIEW": "Jāpārbauda",
  "payments.state.READY": "Gatavs nosūtīšanai",
  "payments.state.PREPARING": "Tiek sagatavots",
  "payments.state.BANK_DRAFT": "Nosūtīts bankai · gaida parakstu",
  "payments.state.PROCESSING": "Banka apstrādā",
  "payments.state.PAID": "Apmaksāts",
  "payments.state.PARTIAL": "Daļēji apmaksāts",
  "payments.state.ATTENTION": "Jāprecizē",
  "payments.state.CANCELLED": "Atcelts",
  "payments.source.awaitingAccounting": "Gaida uzskaiti Goods sadaļā",
  "payments.source.pending": "Gaida maksājuma ierakstu",
  "payments.source.beforeEnablement": "Uzskaitīts pirms maksājumu uzskaites ieslēgšanas",
  "payments.source.unavailable": "Maksājuma statuss nav pieejams",
  "payments.source.open": "Atvērt maksājumu",
  "payments.default.label": "Noklusējuma maksājumu konts",
  "payments.default.set": "Iestatīt kā noklusējumu",
  "payments.default.saved": "Noklusējuma konts saglabāts. Esošo melnrakstu konti nav mainīti.",
  "payments.workspace.preparationHint": "Izvēlieties viena saņēmēja rēķinus, lai apvienotu tos maksājumā. Pirms melnrakstu nosūtīšanas bankai pārbaudiet kontu, kopsummu un maksājuma mērķi.",
  "payments.workspace.sourceFilter": "Izvēlētā rēķina maksājumi",
  "payments.workspace.clearSource": "Rādīt visus maksājumus",
  "payments.state.CLOSED": "Saistības slēgtas",
  "payments.state.PARTIALLY_CLOSED": "Saistības daļēji slēgtas",
  "payments.state.CREDIT": "Piegādātāja kredīts ieskaitam",
  "payables.title": "Payables",
  "payables.sections": "Maksājumu saraksts",
  "payables.section.DUE": "Jāapmaksā",
  "payables.section.WORKING": "Procesā",
  "payables.section.COMPLETE": "Pabeigti",
  "payables.section.ALL": "Visi",
  "payables.search": "Meklēt saņēmēju",
  "payables.tools": "Citas darbības",
  "payables.back": "Atpakaļ pie maksājumiem",
  "payables.visibleInvoices": "Parādītie rēķini: {count}",
  "payables.selectInvoice": "Atlasīt {invoices}",
  "payables.selected": "Atlasīti: {count}",
  "payables.negativeSelection": "Atlasiet rēķinus kredīta ieskaitam.",
  "payables.prepare": "Sagatavot maksājumus",
  "payables.retry": "Mēģināt vēlreiz",
  "payables.reviewInvoice": "Pārbaudīt rēķinu",
  "payables.checkResult": "Pārbaudīt rezultātu",
  "payables.history": "Skatīt vēsturi",
  "payables.resolve": "Skatīt informāciju",
  "payables.continue": "Turpināt",
  "payables.lastCheck": "Pēdējais atjauninājums",
  "payables.supportCode": "Atbalsta kods",
  "payables.partPaid": "Samaksāts {paid} · atlikums {remaining}",
  "payables.partOffset": "Segts {paid} · atlikums {remaining}",
  "payables.operationUncertain": "Daļa šī maksājumu saraksta rezultātu jāprecizē. Pirms atkārtotas nosūtīšanas pārbaudiet sarakstu.",
  "payables.uncertain": "Rezultāts nav apstiprināts. Pārbaudiet to pirms atkārtotas nosūtīšanas.",
  "payables.emptyFiltered": "Atbilstošu rēķinu vai maksājumu nav.",
  "payables.empty.DUE": "Nav apmaksājamu rēķinu.",
  "payables.empty.WORKING": "Nav maksājumu procesā.",
  "payables.empty.COMPLETE": "Nav pabeigtu maksājumu.",
  "payables.empty.ALL": "Rēķinu un maksājumu vēl nav.",
  "payables.state.REVIEW": "Jāpārbauda",
  "payables.state.READY": "Var apmaksāt",
  "payables.state.PREPARING": "Sagatavots",
  "payables.state.BANK_DRAFT": "Parakstīt bankā",
  "payables.state.PROCESSING": "Tiek apstrādāts",
  "payables.state.PAID": "Samaksāts",
  "payables.state.PARTIAL": "Daļēji samaksāts",
  "payables.state.ATTENTION": "Jāprecizē",
  "payables.state.CANCELLED": "Atcelts",
  "payables.state.CLOSED": "Saistības segtas",
  "payables.state.PARTIALLY_CLOSED": "Daļēji segts",
  "payables.state.CREDIT": "Kredīts ieskaitam",
  "payables.issue.NOT_CREATED": "Melnraksts nav izveidots",
  "payables.issueBody.NOT_CREATED": "Atveriet maksājuma informāciju, novērsiet problēmu un atkārtojiet sagatavošanu.",
  "payables.issue.PAYABLE_REVIEW": "Jāpārbauda rēķins",
  "payables.issue.EXPIRED": "Sagatavošanas termiņš beidzies",
  "payables.issue.BANK_REJECTED": "Banka noraidīja maksājumu",
  "payables.issue.RESULT_UNCONFIRMED": "Jāprecizē",
  "payables.issue.TIME_BUDGET": "Sagatavošana apturēta",
  "payables.issue.STATUS_UNAVAILABLE": "Jāprecizē",
  "payables.issueBody.PAYABLE_REVIEW": "Pārbaudiet rēķina datus.",
  "payables.issueBody.EXPIRED": "Atveriet saglabāto sagatavošanu un atlasiet aktuālos rēķinus.",
  "payables.issueBody.BANK_REJECTED": "Pārbaudiet bankas rezultātu un maksājuma datus.",
  "payables.issueBody.TIME_BUDGET": "Izveidotie melnraksti ir saglabāti. Turpiniet pārējo rēķinu sagatavošanu.",
};
